import usersData from "../../mock/users.json";
import { HttpClient } from "../../services/api/httpclient.service";

export class PlayGroundService extends HttpClient {
  constructor() {
    super();
  }

  public async testdata() {
    try {
      const response = await this.mocktestdata();      
      return {
        success: true,
        data: response.data,
      };      
      
    } catch (error: any) {
      console.error("Login service error:", error);
      throw {
        success: false,
        message: error.response?.data?.detail || "Login failed",
      };
    }
  }

    public async GETSOLUTIONCONTENT(exercise_id: number ) {
        try {
            const response = await this.get(`/data/get_exercise_content/${exercise_id}`);
            return response;
        } catch (error: any) {
            console.error('Get exercise content API error:', error.response?.data || error.message);
            throw error;
        }  

      }

  private async mocktestdata() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {        
        const data = '1.  זמן ההליכה של נדב קדימה:$$t_1 = \frac{1.8}{v}\$$'
        
        resolve({ success: true, data });
        
      }, 1000); // Simulating network delay
    });
  }
}
